/**
 * Legacy slim strip above the navbar. Contact and sign-in now live in `TopNavBar`
 * (GetYourGuide-style header). Pages still import `<TopBar />` for layout parity.
 */
const TopBar = () => null;

export default TopBar;
